<template>
    <v-container>
        <br>
        <h2>¿Quiéres saber más de LaCartaWeb?</h2>
        <br>

        <v-row justify="center">
            <v-col cols="6">
                <v-btn color="green" dark v-on:click="navegarNavBar('WhatsApp')">WhatsApp</v-btn>
            </v-col>
            <v-col cols="6">
                <v-btn color="#ffc068" dark v-on:click="navegarNavBar('Llamar')">Llamar</v-btn>
            </v-col>
        </v-row>

        <v-divider width="80%"></v-divider>
        <br>


        <v-row justify="center">
            <v-col cols="10" class="text-left">
                <h4>Versión Gratuita</h4>
                <br>
                <ul>
                    <li>Sube tu carta en PDF</li>
                </ul>
            </v-col>
        </v-row>

        <v-divider width="80%"></v-divider>
        <br>

        <v-row justify="center">
            <v-col cols="10" class="text-left">
                <h4>Versión Profesional</h4>
                <br>
                <p>Disfruta de la carta digital más avanzada del mercado:</p>
                <ul>
                    <li><b>Filtro de alérgenos.</b> Selecciona tus intolerancias alimentarias y todos los platos que las contengas desaparecerán de tu carta.</li>
                    <li><b>Carta dinámica</b> ¿Quieres potenciar algunos platos? ¿Quieres destacar las sugerencias del día? ¿Te has quedado sin algún plato? ¿Quieres añadir un plato de temporada?. <b>Gestiona tu carta tu mismo.</b></li>
                    <li><b>Idiomas</b> Nunca fue tan fácil explicarle a un británico que no sabe lo que es un Serranito.</li>
                    <li><b>Comandas (Próximamente..)</b> Los camareros sólo tendrán que resolver dudas, dar sugerencias y repartir los platos. ¡Gana en eficacia, optimiza tu negocio!</li>
                </ul>
            </v-col>
        </v-row>

        <v-row justify="center">
            <v-col cols="6">
                <v-btn color="#ffc068" dark v-on:click="navegarNavBar('MasInfo')">Más información</v-btn>
            </v-col>
        </v-row>
        
    </v-container>
</template>

<script>
    export default {
        methods: {    
            navegarNavBar: function (donde) {

                if(donde === 'WhatsApp') {
                    window.location.href = 'https://wa.me/34628857556?text=LaCartaWeb';
                } else if (donde === 'Llamar') {
                    window.location.href = 'tel:+34628857556';
                } else if (donde === 'MasInfo') {
                    window.location.href = 'https://lacartaweb.com/hola';
                }


                
            },
        }
    };
</script>
